import { Outlet } from 'react-router-dom';
import { MeHeader } from './components/me-header.component';
import { PageListLayout } from '../../components/layout/page-list-layout';

export function MeLayout() {
  return (
    <PageListLayout>
      <MeHeader />
      <Outlet />
    </PageListLayout>
  );
}
